export default __webpack_public_path__ + "39fdba3c4e7b8323762cd43613dd5302.svg";